import { defineMessages } from 'react-intl';

import { OrganizationJobPosition } from '@/shared/api/protocol-ts/model/dto_organization_job_position_pb';
import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';

export const specialityType = defineMessages<OrganizationJobPosition>({
  [OrganizationJobPosition.OrganizationJobPositionInvalidValue]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionInvalidValue',
    defaultMessage: 'Invalid Value',
  },
  [OrganizationJobPosition.OrganizationJobPositionChiefDentalOfficer]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionChiefDentalOfficer',
    defaultMessage: 'Chief Dental Officer',
  },
  [OrganizationJobPosition.OrganizationJobPositionTreatmentCoordinator]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionTreatmentCoordinator',
    defaultMessage: 'Treatment Coordinator',
  },
  [OrganizationJobPosition.OrganizationJobPositionDentalAssistant]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionDentalAssistant',
    defaultMessage: 'Dental Assistant',
  },
  [OrganizationJobPosition.OrganizationJobPositionDentalTechnician]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionDentalTechnician',
    defaultMessage: 'Dental Technician',
  },
  [OrganizationJobPosition.OrganizationJobPositionGeneralDentist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionGeneralDentist',
    defaultMessage: 'General Dentist',
  },
  [OrganizationJobPosition.OrganizationJobPositionPeriodontist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPeriodontist',
    defaultMessage: 'Periodontist',
  },
  [OrganizationJobPosition.OrganizationJobPositionProsthodontist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionProsthodontist',
    defaultMessage: 'Prosthodontist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOrthodontist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOrthodontist',
    defaultMessage: 'Orthodontist',
  },
  [OrganizationJobPosition.OrganizationJobPositionPediatricDentist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPediatricDentist',
    defaultMessage: 'Pediatric Dentist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOralAndMaxillofacialSurgeon]:
    {
      id: 'OrganizationJobPosition.OrganizationJobPositionOralAndMaxillofacialSurgeon',
      defaultMessage: 'Oral And Maxillofacial Surgeon',
    },
  [OrganizationJobPosition.OrganizationJobPositionOralAndMaxillofacialRadiologist]:
    {
      id: 'OrganizationJobPosition.OrganizationJobPositionOralAndMaxillofacialRadiologist',
      defaultMessage: 'Oral And Maxillofacial Radiologist',
    },
  [OrganizationJobPosition.OrganizationJobPositionAestheticDentist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionAestheticDentist',
    defaultMessage: 'Aesthetic Dentist',
  },
  [OrganizationJobPosition.OrganizationJobPositionDentalHygienist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionDentalHygienist',
    defaultMessage: 'Dental Hygienist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOther]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOther',
    defaultMessage: 'Other',
  },
  [OrganizationJobPosition.OrganizationJobPositionOfficeManager]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOfficeManager',
    defaultMessage: 'Office Manager',
  },
  [OrganizationJobPosition.OrganizationJobPositionEndodontist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionEndodontist',
    defaultMessage: 'Endodontist',
  },
  [OrganizationJobPosition.OrganizationJobPositionDentalTherapist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionDentalTherapist',
    defaultMessage: 'Dental Therapist',
  },
  [OrganizationJobPosition.OrganizationJobPositionImplantologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionImplantologist',
    defaultMessage: 'Implantologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionGeneralPractitioner]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionGeneralPractitioner',
    defaultMessage: 'General Practitioner',
  },
  [OrganizationJobPosition.OrganizationJobPositionInternist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionInternist',
    defaultMessage: 'Internist',
  },
  [OrganizationJobPosition.OrganizationJobPositionPediatrician]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPediatrician',
    defaultMessage: 'Pediatrician',
  },
  [OrganizationJobPosition.OrganizationJobPositionGeneralSurgeon]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionGeneralSurgeon',
    defaultMessage: 'General Surgeon',
  },
  [OrganizationJobPosition.OrganizationJobPositionCardiologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionCardiologist',
    defaultMessage: 'Cardiologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionNeurologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionNeurologist',
    defaultMessage: 'Neurologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOphthalmologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOphthalmologist',
    defaultMessage: 'Ophthalmologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOtolaryngologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOtolaryngologist',
    defaultMessage: 'Otolaryngologist (ENT)',
  },
  [OrganizationJobPosition.OrganizationJobPositionDermatologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionDermatologist',
    defaultMessage: 'Dermatologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionObstetricianGynecologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionObstetricianGynecologist',
    defaultMessage: 'Obstetrician-Gynecologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionUrologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionUrologist',
    defaultMessage: 'Urologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionEndocrinologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionEndocrinologist',
    defaultMessage: 'Endocrinologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionGastroenterologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionGastroenterologist',
    defaultMessage: 'Gastroenterologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionPulmonologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPulmonologist',
    defaultMessage: 'Pulmonologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionRheumatologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionRheumatologist',
    defaultMessage: 'Rheumatologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOncologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOncologist',
    defaultMessage: 'Oncologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionOrthopedicSurgeon]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionOrthopedicSurgeon',
    defaultMessage: 'Orthopedic Surgeon',
  },
  [OrganizationJobPosition.OrganizationJobPositionPsychiatrist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPsychiatrist',
    defaultMessage: 'Psychiatrist',
  },
  [OrganizationJobPosition.OrganizationJobPositionAllergistImmunologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionAllergistImmunologist',
    defaultMessage: 'Allergist-Immunologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionInfectiousDiseaseSpecialist]:
    {
      id: 'OrganizationJobPosition.OrganizationJobPositionInfectiousDiseaseSpecialist',
      defaultMessage: 'Infectious Disease Specialist',
    },
  [OrganizationJobPosition.OrganizationJobPositionNephrologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionNephrologist',
    defaultMessage: 'Nephrologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionAnesthesiologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionAnesthesiologist',
    defaultMessage: 'Anesthesiologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionRadiologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionRadiologist',
    defaultMessage: 'Radiologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionEmergencyPhysician]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionEmergencyPhysician',
    defaultMessage: 'Emergency Physician',
  },
  [OrganizationJobPosition.OrganizationJobPositionNeurosurgeon]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionNeurosurgeon',
    defaultMessage: 'Neurosurgeon',
  },
  [OrganizationJobPosition.OrganizationJobPositionPlasticSurgeon]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPlasticSurgeon',
    defaultMessage: 'Plastic Surgeon',
  },
  [OrganizationJobPosition.OrganizationJobPositionGeriatrician]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionGeriatrician',
    defaultMessage: 'Geriatrician',
  },
  [OrganizationJobPosition.OrganizationJobPositionPhysiatrist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionPhysiatrist',
    defaultMessage: 'Physiatrist',
  },
  [OrganizationJobPosition.OrganizationJobPositionHematologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionHematologist',
    defaultMessage: 'Hematologist',
  },
  [OrganizationJobPosition.OrganizationJobPositionNeonatologist]: {
    id: 'OrganizationJobPosition.OrganizationJobPositionNeonatologist',
    defaultMessage: 'Neonatologist',
  },
});

export const printNameMessages = defineMessages({
  label: {
    id: 'organization.printName.label',
    defaultMessage: 'Name on printed reports',
  },
});

export enum PermissionStatuses {
  'Manage company settings' = 'Manage company settings',
  'Manage payments and subscriptions' = 'Manage payments and subscriptions',
  'View and manage staff' = 'View and manage staff',
  'View and manage patients' = 'View and manage patients',
  'Share patients' = 'Share patients',
  "Manage patient's reports" = "Manage patient's reports",
}

export const permissionOwners = defineMessages<OrganizationStaffRoleType>({
  [OrganizationStaffRoleType.OrganizationStaffRoleType_InvalidValue]: {
    id: 'permissionOwners.InvalidValue',
    defaultMessage: ' ',
  },
  [OrganizationStaffRoleType.OrganizationStaffRoleType_FullAccess]: {
    id: 'permissionOwners.Owner',
    defaultMessage: 'Full access',
  },
  [OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess]: {
    id: 'permissionOwners.Leader',
    defaultMessage: 'Clinical access',
  },
  [OrganizationStaffRoleType.OrganizationStaffRoleType_LimitedClinicalAccess]: {
    id: 'permissionOwners.Doctor',
    defaultMessage: 'Limited clinical access',
  },
  [OrganizationStaffRoleType.OrganizationStaffRoleType_NonClinicalMember]: {
    id: 'permissionOwners.member',
    defaultMessage: 'Non-clinical Member',
  },
});

export const permissionOwnersComments =
  defineMessages<OrganizationStaffRoleType>({
    [OrganizationStaffRoleType.OrganizationStaffRoleType_InvalidValue]: {
      id: 'permissionComments.InvalidValue',
      defaultMessage: ' ',
    },
    [OrganizationStaffRoleType.OrganizationStaffRoleType_FullAccess]: {
      id: 'permissionComments.Owner',
      defaultMessage: ' ',
    },
    [OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess]: {
      id: 'permissionComments.Leader',
      defaultMessage: 'View all patients and their reports',
    },
    [OrganizationStaffRoleType.OrganizationStaffRoleType_LimitedClinicalAccess]:
      {
        id: 'permissionComments.Doctor',
        defaultMessage: 'View only assigned patients and their reports',
      },
    [OrganizationStaffRoleType.OrganizationStaffRoleType_NonClinicalMember]: {
      id: 'permissionComments.member',
      defaultMessage: 'View and manage patients',
    },
  });

export const permissionDescriptions = defineMessages<PermissionStatuses>({
  [PermissionStatuses['Manage company settings']]: {
    id: 'permissionDescriptions.manageCompanySettings',
    defaultMessage: 'Manage company settings',
  },
  [PermissionStatuses['Manage payments and subscriptions']]: {
    id: 'permissionDescriptions.managePaymentsAndSubscriptions',
    defaultMessage: 'Manage payments and subscriptions',
  },
  [PermissionStatuses['View and manage staff']]: {
    id: 'permissionDescriptions.viewAndManageStaff',
    defaultMessage: 'View and manage staff',
  },
  [PermissionStatuses['View and manage patients']]: {
    id: 'permissionDescriptions.viewAndManagePatients',
    defaultMessage: 'View and manage patients',
  },
  [PermissionStatuses['Share patients']]: {
    id: 'permissionDescriptions.sharePatients',
    defaultMessage: 'Share patients',
  },
  [PermissionStatuses["Manage patient's reports"]]: {
    id: 'permissionDescriptions.managePatientsReports',
    defaultMessage: "Manage patient's reports",
  },
});
